import Isotope from 'isotope-layout'
import packery from 'isotope-packery'
import Channels from '../../base/channels'
import Env from '../../base/env';

export default class Grid
{
    constructor(view)
    {
        this.view  = view
        this.reference = this.view
        this.$sizers = this.view.querySelectorAll('.jsSizer')
        this.gutter = (Env.mobileCSS)?15:30
        this.klassItems = '.jsIsotope--item'
        this.klassSizer = '.jsIsotope--sizer'
        this.funcSizer = this.resize.bind(this)
        this.dimensionsGrid = { width : 320 , height : 420 }
        if(Env.mobileCSS) {
            this.dimensionsGrid = { width : 295 , height : 392 }
        }
    }

    destroy()
    {
        Channels.removeListener('window::smartresize',this.funcSizer)
    }

    events()
    {
        Channels.on('window::smartresize',this.funcSizer)
    }

    setup()
    {
        this.sizeGrid()

        this.isotope = new Isotope( this.reference , {
            // options
            itemSelector: this.klassItems,
            percentPosition: true,
            layoutMode: 'packery',
            packery : {
                gutter : this.gutter
            }
        });
        this.events()
    }

    resize()
    {
        this.sizeGrid()

        if(typeof this.isotope !== 'undefined') {
            this.isotope.layout()
        }
    }

    sizeGrid()
    {
        const $items = this.view.querySelectorAll(this.klassItems)
        const ratio = this.dimensionsGrid.width / this.dimensionsGrid.height
        const $sizerIsotope = this.view.querySelector(this.klassSizer)

        $sizerIsotope.removeAttribute('style')

        const sizerDimensions = $sizerIsotope.getBoundingClientRect()
        let newSize = { width : sizerDimensions.width - this.gutter , height : 0 }
        newSize.height = newSize.width / ratio


        for(let j = 0; j < $items.length; j++) {
            const $item = $items[j]
            $item.querySelector('.bg').style.height = `${newSize.height}px`
            $item.querySelector('.bg-out').style.height = `${newSize.height}px`
        }
        $sizerIsotope.style.height = `${newSize.height}px`
    }

}